import { NotificationIdentifier } from '@evorait/pace-core';
import { createAction, props } from '@ngrx/store';
import { DocBoxListModel } from '../../services/docBox-odata.interface';
import { DOCUMENT_FILTERS, DocumentState } from '../state/document.state';

export const navigateToDocBox = createAction(
    '[Files] Navigate to DocBox',
    props<{ notificationId: NotificationIdentifier }>(),
);

export const getDocBox = createAction(
    '[Files] Get DocBox',
    props<{
        notificationId: NotificationIdentifier;
        materialNumber: string;
        serialNumber: string;
    }>(),
);

export const getDocBoxSuccess = createAction(
    '[Files] Get DocBox Successful',
    props<{ notificationId: NotificationIdentifier; docBoxData: DocBoxListModel[] }>(),
);

export const getDocBoxError = createAction('[Files] Get DocBox error');

export const downloadDocuments = createAction('[Files] Download Documents', props<{ docBoxIds: string[] }>());

export const downloadDocumentsLoadingStatus = createAction(
    '[Files] Download Document Successful',
    props<{ docBoxId: string[] }>(),
);

export const selectDocument = createAction('[Files] Select Document', props<{ docBoxId: string }>());

export const selectAllDocuments = createAction('[Files] Select All Documents');

export const filterDocuments = createAction(
    '[Files] Filter Documents',
    props<{ property: DOCUMENT_FILTERS; value: string }>(),
);

export const sortByField = createAction('[Files] Sort Documents', props<{ property: keyof DocumentState }>());

export const getDocBoxFromSideMenu = createAction(
    '[Side Menu DocBox] Get DocBox',
    props<{
        materialNumber: string;
        serialNumber: string;
        technicalIdentNo: string;
        functionalLocation: string;
    }>(),
);

export const getDocBoxFromSideMenuSuccess = createAction(
    '[Side Menu DocBox] Get DocBox Successful',
    props<{ docBoxData: DocBoxListModel[] }>(),
);

export const clearDocBoxData = createAction('[DocBox] Clear Documents');
